module.exports = __webpack_public_path__ + "img/home-delivery.188c8d89.webp";